import React from 'react';
import useCollapse from 'react-collapsed';
import {CSVLink, CSVDownload} from 'react-csv';
import {Button} from 'react-bootstrap';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import {Radar} from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  ArcElement,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function ChartRadarCollapsed(props) {
  const {getCollapseProps, getToggleProps, isExpanded} = useCollapse({
    defaultExpanded: true
  });

  let options1 = []; //Array of object
  let month_title = []; //Array of string
  let campaign_title = []; //Array of string

  props.chartdata.forEach((e) => {
    if (!month_title.includes(e.MONTH_YEAR_NAME)) {
      month_title = [...month_title, e.MONTH_YEAR_NAME];
      options1 = [
        ...options1,
        {
          responsive: true,
          plugins: {
            legend: {
              display: false
            },
            title: {
              display: true,
              text: e.MONTH_YEAR_NAME
            },
          }
        }
      ];
    }

    if (!campaign_title.includes(e.TITLE)) {
      campaign_title = [...campaign_title, e.TITLE];
    }
  });

  const backgroundColor = [
    'rgba(255, 99, 132,',
    'rgba(54, 162, 235,',
    'rgba(255, 206, 86,',
    'rgba(75, 192, 192,',
    'rgba(153, 102, 255,',
    'rgba(255, 159, 64,'
  ]

  const percentage = (a , b) =>{
    return Math.round((a / b) * 100)
  }

  const generateDataFromSet = (datas) =>{
    let datasets = [];
    campaign_title.forEach((e, i) =>{
      datasets = [...datasets,{
        label: e,
        data: datas.reduce((prev, curr) => {
          if (curr.TITLE === e) return [...prev, curr.AMOUNT];
          else return [...prev];
        }, []),
        backgroundColor: `${backgroundColor[i]} 0.2)`,
        borderColor: `${backgroundColor[i]} 1)`,
        borderWidth: 1,
      }]
    })

    return datasets;
  }

  const formatRadar = (datas) => {
    const total1 = datas.reduce((prev, curr) => {
      return prev + curr.AMOUNT;
    }, 0);

    let _data = {
      labels: datas
            .filter((e) => (e.TITLE === campaign_title[0]))
            .reduce((prev, curr) => {
            return [...prev, curr.TITLE2];
          }, []),
      datasets: generateDataFromSet(datas),
    };
    return _data;
  };

  return (
    <div className="card card-warning" id="card1">
      <div className="card-header">
        <h3 className="card-title">{props.chartname}</h3>
        <div className="card-tools">
          {/* <button
            type="button"
            className="btn btn-tool"
            data-card-widget="collapse"
            {...getToggleProps()}
          >
            <i className={isExpanded ? 'fas fa-minus' : 'fas fa-plus'}></i>
          </button> */}
        </div>
      </div>
      <div className="card-body" {...getCollapseProps()}>
        <div className='row'>
        {
          campaign_title
          .map((e, i) => (
            <div class="col-sm-3 col-md-3"><div style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: 12,
              justifyContent: 'center',
              backgroundColor: `${backgroundColor[i]} 0.5)`
            }}>{e}</div></div>
          ))
        }
        </div>
        <div className="chart">
          <div className="row">
            {month_title.map((e, i) => (
              <div className="col-12 col-sm-6 col-md-6" key={i}>
                <Radar
                  datasetIdKey='id'
                  key={Math.random()}
                  options={options1[i]}
                  // data={{
                  //   labels: ['Thing 1', 'Thing 2', 'Thing 3', 'Thing 4', 'Thing 5', 'Thing 6'],
                  //   datasets: formatRadar(
                  //     props.chartdata.filter((e) => {
                  //       return e.MONTH_YEAR_NAME === month_title[i];
                  //     })
                  //   ),
                  // }}

                  data={formatRadar(
                    props.chartdata.filter((e) => {
                      return e.MONTH_YEAR_NAME === month_title[i];
                    })
                  )}

                  style={{
                    minHeight: 220,
                    height: 220,
                    maxHeight: 220,
                    maxWidth: '100%',
                    display: 'block'
                  }}

                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="card-footer">
        <CSVLink filename={props.chartname} className="btn btn-primary" data={props.csvdata}>
          CSV
        </CSVLink>
        <Button variant="success" className='ml-2' onClick={()=>{props.export(props.csvdata, props.chartname)}}>Excel</Button>
      </div>
    </div>
  );
}
